export default __webpack_public_path__ + "0a9c777dbb66bd48b42abcbdd44387bf.png";